import {
  DynamicPromoCard,
  Header
} from '../../PromoTiles/DynamicPromoTile/DynamicPromoTile.styles';
import {
  SkeletonImage,
  SkeletonTextLarge,
  SkeletonTextMedium,
  SkeletonTextSmall
} from '../Skeleton.styles';

const DynamicPromoTileSkeleton = () => {
  return (
    <DynamicPromoCard>
      <Header>
        <SkeletonTextLarge className="!h-32 max-w-[250px]" />
        <SkeletonTextSmall className="max-w-[150px]" />
      </Header>
      <SkeletonImage className="!h-[160px] m:!h-[204px]" />
      <SkeletonTextMedium />
    </DynamicPromoCard>
  );
};

export default DynamicPromoTileSkeleton;
